<template>
    <div class="vue-area-manager-teaser">
        <div class="avatar-picture">
            <img v-if="hasAvatar" :src="item.avatar" :alt="item.name">
        </div>

        <div class="content-wrapper">
            <h4>{{ item.name }}</h4>

            <div class="field--type-email">
                <a :href="`mailto:${item.email_address}`">{{ item.email_address }}</a>
            </div>
            <div class="field--type-telephone">
                <a :href="`tel:${item.phone_number}`">{{ item.phone_number }}</a>
            </div>

            <div class="field--name-field-regions">
                {{ item.region }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AreaManagerTeaser",

    props: {
        item: {
            type: Object,
            required: true,
        }
    },

    computed: {
        hasAvatar() {
            return !_.isEmpty(this.item.avatar)
        }
    }
}
</script>